<template>
  <tr>
  	<td v-if="showCode">{{item.item_code}}</td>
    <!-- <td>{{item.title}}</td> -->
    <!-- <td>{{item.unit_name}}</td> -->
    <!-- <td class="text-xs-right" v-if="showPrice">{{ item.rate | roundValue }}</td> -->
    <td :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">{{purchaseQty}}</td>
    <td class="text-xs-right">
      <span v-if="viewMode || approveMode">{{ item.damage_quantity }}</span>
      <v-edit-dialog v-else :return-value="damage_quantity" lazy @open="openDamage" @close="closeDamage"> {{ item.damage_quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="damage_quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td class="text-xs-right">
      <span v-if="viewMode || approveMode">{{ item.non_damage_quantity }}</span>
      <v-edit-dialog v-else :return-value="non_damage_quantity" lazy @open="openNonDamage" @close="closeNonDamage"> {{ item.non_damage_quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="non_damage_quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">{{item.quantity}}</td>
    <td class="text-xs-right" v-if="showPrice">{{ item.total | roundValue }}</td>
    <td class="align-right justify-end layout px-2" v-if="!viewMode && !approveMode">
      <v-btn flat icon @click="$emit('delete', index)">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
<script>

export default {
  name: 'SalesReturnItem' ,
  props: {
    item: {
      type: Object,
      required: true
    },
    invoiceItems: {
      type: Array,
      required: true
    },
    index: {
      required: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    approveMode: {
      type: Boolean,
      default: false
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    showCode: {
      type: Boolean,
      default: true
    },
    showTax: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      damage_quantity: 0,
      non_damage_quantity: this.item.non_damage_quantity,
      quantityRules: [
        v => !!v || 'Quantity is required',
        v => /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Quantity must be valid'
      ]
    }
  },
  
  methods: {
  	openNonDamage () {
      this.non_damage_quantity = this.item.non_damage_quantity
    },
    closeNonDamage () {
      this.item.non_damage_quantity = this.item.allow_decimal ? this.non_damage_quantity : parseInt(this.non_damage_quantity)
    },
    openDamage () {
      this.damage_quantity = this.item.damage_quantity
    },
    closeDamage () {
      this.item.damage_quantity = this.item.allow_decimal ? this.damage_quantity : parseInt(this.damage_quantity)
    }
  },

  mounted () {
  	this.item.total = this.item.quantity * ( this.item.rate + this.item.tax )
  },

  computed: {
    
    itemTotal () {
      return this.totalItems * ( this.item.rate + this.item.tax )
    },

    totalItems () {
      return this.item.non_damage_quantity + this.item.damage_quantity
    },
    
    purchaseQty() {
      let qty = 0
      let current = this.invoiceItems.filter(item => item.item_id === this.item.item_id)
      if (current.length > 0) {
        current = current[0]
        qty = current.quantity
      }
      return qty
    }

  },

  watch: {

    itemTotal (val) {
      if (val) {
        this.item.total = val
      }
    },
  	
    totalItems (val, oldVal) {
  		if (!val || val < 0) {
        return this.item.quantity = 0
  		}

      this.item.quantity = val

      if (this.item.quantity > this.purchaseQty) {
        this.item.quantity = this.purchaseQty
      }
  	},

    'item.non_damage_quantity' (val, oldVal) {
      if (!val || val < 0) {
        return this.item.non_damage_quantity = 0
      }
      else if(val > this.purchaseQty){
        return this.item.non_damage_quantity = this.purchaseQty
      }

      if (this.totalItems > this.purchaseQty) {
        this.item.damage_quantity = this.purchaseQty - this.item.non_damage_quantity
      }
    },

    'item.damage_quantity' (val, oldVal) {
      if (!val || val < 0) {
        return this.item.damage_quantity = 0
      }
      else if(val > this.purchaseQty){
        return this.item.damage_quantity = this.purchaseQty
      }

      if (this.totalItems > this.purchaseQty) {
        this.item.non_damage_quantity = this.purchaseQty - this.item.damage_quantity
      }
    }
    
  }
}
</script>